<div class="container-layout h-fixed-500">
  <div class="container-fluid container-content">
    <div class="marquee marquee-danger">
      <i class="far fa-lock-alt marquee-icon"></i>
      <h1 class="marquee-heading">{{ 'APP.ACCESS_DENIED.TITLE' | translate }}</h1>
      <h2 class="marquee-message">{{ 'APP.ACCESS_DENIED.MESSAGE' | translate }}</h2>
    </div>
  </div>
</div>